exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".popover-content[data-v-2577c1d0],.popover-content[data-v-2577c1d0]:after{background-color:#fef7ea}.form-check[data-v-2577c1d0]{font-size:.8rem}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-2577c1d0&scoped=true!./~/sass-loader!./~/vue-loader/lib/selector.js?type=styles&index=1!./src/components/popover/CartPhotoSizeChangePopover.vue
// module id = 490
// module chunks = 0